import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useLogin } from '../features/auth/useAuth.js';

const schema = z.object({
  email: z.string().email('Email inválido'),
  password: z.string().min(1, 'Requerido'),
});

export default function LoginPage() {
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: zodResolver(schema) });
  const login = useLogin();

  return (
    <div className="min-h-screen flex">

      {/* Panel izquierdo — identidad institucional */}
      <div
        className="hidden md:flex md:w-1/2 flex-col justify-between p-12"
        style={{ background: 'linear-gradient(135deg, #1E9BE8 0%, #0D2B5C 100%)' }}
      >
        <div className="flex-1 flex items-center justify-center">
          <img src="/logo-full.png" alt="Instituto ISADA" className="w-4/5 max-w-md" style={{ filter: 'brightness(0) invert(1)' }} />
        </div>
      </div>

      {/* Panel derecho — formulario */}
      <div className="flex-1 flex flex-col items-center justify-center bg-[#F5F5F5] px-6 py-12">

        {/* Logo visible solo en mobile */}
        <div className="flex flex-col items-center gap-3 mb-8 md:hidden">
          <img src="/logo-escudo.png" alt="Escudo ISADA" className="h-16 w-auto" />
          <p className="font-['Raleway'] font-bold text-[#0D2B5C] text-lg">Instituto ISADA</p>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 shadow-md p-8 w-full max-w-sm flex flex-col gap-6">

          <div className="flex flex-col gap-1">
            <h2 className="font-['Raleway'] font-bold text-[#0D2B5C] text-2xl">Bienvenido</h2>
            <p className="font-['Inter'] text-[#6B7280] text-sm">Ingresá con tu cuenta para continuar</p>
          </div>

          <form onSubmit={handleSubmit((data) => login.mutate(data))} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <label className="font-['Raleway'] text-[#1E9BE8] text-xs font-semibold tracking-widest uppercase">
                Email
              </label>
              <input
                {...register('email')}
                type="email"
                placeholder="usuario@isada.edu.ar"
                className="border border-gray-200 rounded-md px-3 py-2.5 text-sm font-['Inter'] focus:outline-none focus:ring-2 focus:ring-[#1E9BE8] placeholder:text-gray-300"
              />
              {errors.email && <span className="text-red-500 text-xs font-['Inter']">{errors.email.message}</span>}
            </div>

            <div className="flex flex-col gap-1">
              <label className="font-['Raleway'] text-[#1E9BE8] text-xs font-semibold tracking-widest uppercase">
                Contraseña
              </label>
              <input
                {...register('password')}
                type="password"
                placeholder="••••••••"
                className="border border-gray-200 rounded-md px-3 py-2.5 text-sm font-['Inter'] focus:outline-none focus:ring-2 focus:ring-[#1E9BE8] placeholder:text-gray-300"
              />
              {errors.password && <span className="text-red-500 text-xs font-['Inter']">{errors.password.message}</span>}
            </div>

            {login.error && (
              <p className="text-red-500 text-sm font-['Inter']">Credenciales inválidas</p>
            )}

            <button
              type="submit"
              disabled={login.isPending}
              className="mt-1 text-white font-['Raleway'] font-bold text-sm px-6 py-3 rounded-md transition-colors min-h-[44px] disabled:opacity-50"
              style={{ background: 'linear-gradient(135deg, #1E9BE8 0%, #0D2B5C 100%)' }}
            >
              {login.isPending ? 'Ingresando...' : 'Ingresar'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
